/* eslint-disable max-lines */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { Field, FormSection, untouch } from 'redux-form';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import InputCheckbox from '../../../../../../../../common/atoms/InputCheckbox';
import withStyles from '../../../../../../../../common/hoc/withStyles';
import SMSFormFields from '../../../../../../../../common/molecules/SMSFormFields';
import {
  REG_FORM_MODE,
  ADDRESS_FORM_MODE,
} from '../../../../../../SinglePageCheckout/container/Shipping/Shipping.constants';
import ShippingAddressForm from '../../../../../../SinglePageCheckout/molecules/Shipping/ShippingAddressForm.view';
import EmailSignUpCheckBox from '../../../../../molecules/EmailSignUpCheckBox';
import styles from '../styles/RegisteredShippingForm.view.style';
import AddressCarousel from './molecules/AddressCarousel';
import { defaultProps, propTypes } from './RegisteredShippingForm.util';
import { getIsGuestUser } from '../../../../../../../../../utils/utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../../../utils/labels/labelUtilty';
import ShippingPageLabels, {
  ACCOUNT_COMMON_LABELS,
  ADDRESS_LABELS,
  BILLING_LABELS,
  SHIPPING_LABELS,
} from '../../../views/ShippingPage.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblCancel,
} from '../../../../../../../../../utils/labels/globalActions.labels';

const getAddressField1 = (address) => {
  return address?.addressLine ? address?.addressLine[0] : '';
};
let isDefaultShippingDisabled = false;
const getAddressField2 = (address) => {
  return address?.addressLine ? address?.addressLine[1] : '';
};
class RegisteredShippingFormV2 extends React.Component {
  shippingPageLabels = getLabelFromCopyOrFromTranslation(SHIPPING_LABELS, ShippingPageLabels);

  addressSectionLabels = getLabelFromCopyOrFromTranslation(ADDRESS_LABELS, ShippingPageLabels);

  accountCommonLabels = getLabelFromCopyOrFromTranslation(
    ACCOUNT_COMMON_LABELS,
    ShippingPageLabels
  );

  billingLabels = getLabelFromCopyOrFromTranslation(BILLING_LABELS, ShippingPageLabels);

  constructor(props) {
    super(props);
    const { savedAddress: { addressId } = {} } = props;
    this.state = { selectedShippingId: addressId || '' };
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  componentDidMount() {
    const {
      formName,
      userAddresses,
      loadShipmentMethods,
      updateSectionState,
      savedAddress,
      openFormForVerification,
    } = this.props;
    const { selectedShippingId } = this.state;
    if (isEmpty(userAddresses)) {
      updateSectionState({ registeredUserFormMode: REG_FORM_MODE.FIRST_ADDRESS });
      if (!selectedShippingId) {
        this.updateShippingForm({}, REG_FORM_MODE.FIRST_ADDRESS);
        updateSectionState({ isMethodAndGiftSectionVisible: false });
        updateSectionState({ isFormExpanded: false });
      } else {
        updateSectionState({ isMethodAndGiftSectionVisible: true });
        updateSectionState({ autoSuggestMode: ADDRESS_FORM_MODE.MANUAL });
        updateSectionState({ isFormExpanded: true });
        this.updateShippingForm(savedAddress);
      }
    } else {
      updateSectionState({ isMethodAndGiftSectionVisible: true });
      updateSectionState({
        registeredUserFormMode: openFormForVerification
          ? REG_FORM_MODE.EDIT_ADDRESS
          : REG_FORM_MODE.VIEW_ADDRESSES,
      });
      updateSectionState({ autoSuggestMode: ADDRESS_FORM_MODE.MANUAL });
      let addressForSM = {};
      if (isEmpty(selectedShippingId)) {
        // Select primary address as default
        // If no primary address present, select the first address by default
        const defaultAddress =
          userAddresses.find((u) => u.preferred === 'true') || userAddresses[0];
        addressForSM = defaultAddress;
        this.updateShippingForm(defaultAddress);
        this.setState({ selectedShippingId: defaultAddress?.addressId });
      } else {
        const selectedAddress = userAddresses.find((u) => u.addressId === selectedShippingId);
        addressForSM = selectedAddress;
        this.updateShippingForm(selectedAddress, undefined, false);
      }
      const { state, stateCode, zipCode, postalCode, address1, address2 } = addressForSM;
      loadShipmentMethods({
        state: state || stateCode,
        zipCode: zipCode || postalCode,
        addressField1: getAddressField1(addressForSM) || address1,
        addressField2: getAddressField2(addressForSM) || address2,
        formName,
      });
      if (!openFormForVerification) {
        updateSectionState({ isFormExpanded: false });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.section?.isFormExpanded !== this.props?.section?.isFormExpanded) {
      const {
        dispatchFormFieldChange,
        shippingFormInput: { saveToAddressBook },
      } = this.props;
      dispatchFormFieldChange('saveToAddressBook', true);
      if (saveToAddressBook !== undefined && saveToAddressBook !== null) {
        dispatchFormFieldChange('saveToAddressBook', saveToAddressBook);
        isDefaultShippingDisabled = !saveToAddressBook;
      }
    }
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  updateShippingForm = (address = {}, mode, shouldLoadShipmentMethods = true) => {
    const {
      formName,
      dispatchFormFieldChange,
      dispatch,
      loadShipmentMethods,
      updateSectionState,
      isInternationalPhoneNumberEnabled,
    } = this.props;
    const {
      addressId = '',
      firstName = '',
      lastName = '',
      addressLine1: addrLine1 = '',
      addressLine2: addrLine2 = '',
      addressLine: [addressLine1 = '', addressLine2 = ''] = [],
      zipCode = '',
      city = '',
      state = '',
      address1 = '',
      address2 = '',
      postalCode = '',
      stateCode = '',
      countryCode: country = '',
      countryCode,
      preferred = false,
      phone = '',
      phoneCountryCode = '',
    } = address;
    dispatchFormFieldChange('addressId', addressId);
    dispatchFormFieldChange('firstName', firstName);
    dispatchFormFieldChange('lastName', lastName);
    dispatchFormFieldChange('addressLine1', addressLine1 || addrLine1 || address1);
    dispatchFormFieldChange('addressLine2', addressLine2 || addrLine2 || address2);
    dispatchFormFieldChange('zipCode', zipCode || postalCode);
    dispatchFormFieldChange('city', city);
    dispatchFormFieldChange('state', state || stateCode);
    dispatchFormFieldChange('country', country || countryCode);
    dispatchFormFieldChange('phoneNumber', phone);
    if (isInternationalPhoneNumberEnabled) {
      dispatchFormFieldChange('phoneCountryCode', phoneCountryCode);
    }
    if (addressId.length > 0 && !addressId.includes('me')) {
      const isPreferred = preferred && (preferred === 'true' || preferred === true);
      dispatchFormFieldChange('saveToAddressBook', true);
      dispatchFormFieldChange('defaultShipping', isPreferred);
    } else {
      dispatchFormFieldChange('saveToAddressBook');
      dispatchFormFieldChange('defaultShipping', true);
    }
    dispatch(
      untouch(
        formName,
        'addressId',
        'firstName',
        'lastName',
        'addressLine1',
        'addressLine2',
        'zipCode',
        'city',
        'state',
        'country',
        'saveToAddressBook',
        'defaultShipping'
      )
    );
    if (shouldLoadShipmentMethods) {
      loadShipmentMethods({
        state: state || stateCode,
        zipCode: zipCode || postalCode,
        addressField1: addressLine1 || address1,
        addressField2: addressLine2 || address2,
        formName,
      });
    }
    if (mode === REG_FORM_MODE.FIRST_ADDRESS) {
      updateSectionState({ isFormExpanded: false });
    }
  };

  updateRegFormMode = (registeredUserFormMode, addressId) => {
    setTimeout(() => {
      const { userAddresses, updateSectionState, resetShippingEddData } = this.props;
      if (registeredUserFormMode === REG_FORM_MODE.EDIT_ADDRESS && addressId) {
        const selectedAddress = userAddresses.find((u) => u.addressId === addressId);
        this.updateShippingForm(selectedAddress);
        this.setState({
          selectedShippingId: addressId,
        });
        updateSectionState({
          registeredUserFormMode,
          autoSuggestMode: ADDRESS_FORM_MODE.MANUAL,
          isFormExpanded: true,
        });
      } else if (registeredUserFormMode === REG_FORM_MODE.ADD_NEW_ADDRESS) {
        resetShippingEddData();
        updateSectionState({ registeredUserFormMode });
        this.updateShippingForm();
        updateSectionState({ autoSuggestMode: ADDRESS_FORM_MODE.MANUAL, isFormExpanded: false });
      } else if (registeredUserFormMode === REG_FORM_MODE.VIEW_ADDRESSES) {
        const selectedAddress = userAddresses.find((u) => u.addressId === addressId);
        this.updateShippingForm(selectedAddress);
        this.setState({
          selectedShippingId: addressId,
        });
        updateSectionState({ registeredUserFormMode });
      }
    }, 0);
  };

  handleShippingAddressSelect = (addressId) => {
    const { formName, userAddresses, loadShipmentMethods, setPhoneCountryAction } = this.props;
    this.updateRegFormMode(REG_FORM_MODE.VIEW_ADDRESSES, addressId);
    const selectedAddress = userAddresses.find((u) => u.addressId === addressId);
    const {
      state,
      stateCode,
      zipCode,
      postalCode,
      address1,
      address2,
      addressLine,
      phoneCountryCode,
    } = selectedAddress;
    setPhoneCountryAction(phoneCountryCode);
    const [addressLine1, addressLine2] = addressLine || [];
    loadShipmentMethods({
      state: state || stateCode,
      zipCode: zipCode || postalCode,
      addressField1: addressLine1 || address1,
      addressField2: addressLine2 || address2,
      formName,
    });
  };

  cancelAddAddress = () => {
    const { updateSectionState } = this.props;
    const { selectedShippingId } = this.state;
    this.updateRegFormMode(REG_FORM_MODE.VIEW_ADDRESSES, selectedShippingId);
    updateSectionState({
      isFormExpanded: false,
    });
  };

  cancelEditAddress = () => {
    const { selectedShippingId } = this.state;
    const { userAddresses, updateSectionState, setOpenFormForVerification } = this.props;
    const selectedAddress = userAddresses.find((u) => u.addressId === selectedShippingId);
    updateSectionState({
      registeredUserFormMode: REG_FORM_MODE.VIEW_ADDRESSES,
      isFormExpanded: false,
    });
    this.updateRegFormMode(REG_FORM_MODE.VIEW_ADDRESSES, selectedAddress.addressId);
    setOpenFormForVerification(false);
  };

  getHeaderLabel = (isAddAddress, isEditAddress) => {
    if (isAddAddress) {
      return renderLabel(
        this.addressSectionLabels?.lbl_addEditAddress_regAddNewAddress,
        'lbl_addEditAddress_regAddNewAddress'
      );
    }
    if (isEditAddress) {
      return renderLabel(
        this.addressSectionLabels?.lbl_addEditAddress_regEditAddress,
        'lbl_addEditAddress_regEditAddress'
      );
    }
    return '';
  };

  renderAddressFields = () => {
    const {
      section,
      addressLabels,
      mapboxAutocompleteTypesParam,
      mapboxSwitch,
      handleSave,
      addressFormFieldClass,
      shippingFormInput,
      changeZipCode,
      changeShipmentMethods,
      handlePlaceSelected,
      handlePlaceSelectedGmaps,
      zipCodeABTestEnabled,
      getZipCodeSuggestedAddress,
      fillFormManually,
      changeAddress,
      smsSignUpLabels,
      isUsSite,
      emailSignUpFlags,
      emailSignUpLabels,
      emailSignUpCaRichText,
      isChildrenPalace,
      isGymboree,
      isSnJ,
      initialValues,
      isLoginV2FlowEnabled,
      savedEmail,
      emailFailSafe,
      venmoStatus,
      isInternationalPhoneNumberEnabled,
      dispatchFormFieldChange,
      className,
      userAddresses,
      isPlccIC,
      setPhoneCountryAction,
      orderTrackingEnhancementEnabled,
    } = this.props;
    const { selectedShippingId } = this.state;
    const { registeredUserFormMode, isFormExpanded } = section;
    const selectedAddress = userAddresses.find((u) => u.addressId === selectedShippingId);
    const isFirstAddress = registeredUserFormMode === REG_FORM_MODE.FIRST_ADDRESS;
    const isAddAddress = registeredUserFormMode === REG_FORM_MODE.ADD_NEW_ADDRESS;
    const isEditAddress = registeredUserFormMode === REG_FORM_MODE.EDIT_ADDRESS;
    const showAddressFields = isFirstAddress || isAddAddress || isEditAddress;
    const headerLabel = this.getHeaderLabel(isAddAddress, isEditAddress);
    const isAddressFormExpanded = isFormExpanded || false;
    let defaultPhone = '';
    let defaultCountryDialCode = '';
    if (isAddAddress) {
      defaultPhone = '';
      defaultCountryDialCode = '';
    } else if (isFirstAddress) {
      defaultPhone = initialValues?.phone || initialValues?.phoneNumber;
      defaultCountryDialCode = initialValues?.phoneCountryCode;
    } else {
      defaultPhone = selectedAddress?.phone || selectedAddress?.phoneNumber;
      defaultCountryDialCode = selectedAddress?.phoneCountryCode;
    }

    return (
      showAddressFields && (
        <>
          {headerLabel && (
            <Col
              colSize={{ small: 6, medium: 8, large: 12 }}
              className="reg-shipping-header-container"
            >
              <BodyCopy component="h3" className="reg-shipping-header">
                {headerLabel}
              </BodyCopy>
              {(isAddAddress || isEditAddress) && (
                <Button
                  buttonVariation="category-links-dark"
                  dataLocator={isEditAddress ? 'cancelEditAddress' : 'cancelAddAddress'}
                  noLink
                  onClick={isEditAddress ? this.cancelEditAddress : this.cancelAddAddress}
                  className="reg-shipping-edit-btn reg-shipping-parent-cta"
                  aria-label={renderLabel(
                    getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_ACTIONS_LABELS}.${lblCancel}`,
                      GlobalActionsLabels
                    ),
                    'lbl_cancel'
                  )}
                >
                  {renderLabel(
                    getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_ACTIONS_LABELS}.${lblCancel}`,
                      GlobalActionsLabels
                    ),
                    'lbl_cancel'
                  )}
                </Button>
              )}
            </Col>
          )}
          <Col colSize={{ small: 6, medium: 8, large: 12 }}>
            <div className="address-form">
              <ShippingAddressForm
                section={section}
                addressFormLabels={addressLabels}
                formSection="address"
                shippingFormInput={shippingFormInput}
                mapboxSwitch={mapboxSwitch}
                mapboxAutocompleteTypesParam={mapboxAutocompleteTypesParam}
                handlePlaceSelected={handlePlaceSelected}
                handlePlaceSelectedGmaps={handlePlaceSelectedGmaps}
                fillFormManually={fillFormManually}
                handleSave={handleSave}
                addressFormFieldClass={addressFormFieldClass}
                changeZipCode={changeZipCode}
                changeShipmentMethods={changeShipmentMethods}
                zipCodeABTestEnabled={zipCodeABTestEnabled}
                getZipCodeSuggestedAddress={getZipCodeSuggestedAddress}
                changeAddress={changeAddress}
                isUsSite={isUsSite}
                emailSignUpFlags={emailSignUpFlags}
                emailSignUpLabels={emailSignUpLabels}
                emailSignUpCaRichText={emailSignUpCaRichText}
                isSnJ={isSnJ}
                isGymboree={isGymboree}
                isChildrenPalace={isChildrenPalace}
                smsSignUpLabels={smsSignUpLabels}
                initialValues={initialValues}
                isLoginV2FlowEnabled={isLoginV2FlowEnabled}
                savedEmail={savedEmail}
                emailFailSafe={emailFailSafe}
                venmoStatus={venmoStatus}
                isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
                className={className}
                defaultPhoneNumber={defaultPhone}
                defaultCountryCode={defaultCountryDialCode}
                dispatchFormFieldChange={dispatchFormFieldChange}
                isPlccIC={isPlccIC}
                setPhoneCountryAction={setPhoneCountryAction}
                orderTrackingEnhancementEnabled={orderTrackingEnhancementEnabled}
              />
            </div>
          </Col>
          {isAddressFormExpanded && this.renderDefaultOptions()}
        </>
      )
    );
  };

  renderAddressForm = () => {
    const {
      userAddresses,
      section,
      isEditing,
      isUsSite,
      smsSignUpLabels,
      isSnJ,
      isGymboree,
      isChildrenPalace,
      emailSignUpLabels,
      emailSignUpFlags,
      emailSignUpCaRichText,
      isLoginV2FlowEnabled,
      initialValues,
      shippingFormInput,
      defaultAddress,
      isMakeDefaultUxUpdateEnabled,
      makeDefaultAddress,
      orderTrackingEnhancementEnabled,
      isInternationalPhoneNumberEnabled,
    } = this.props;
    const makeDefaultTextLabel = renderLabel(
      this.accountCommonLabels?.lbl_common_makeDefault,
      'lbl_common_makeDefault'
    );
    const addressTextLabel = renderLabel(
      this.accountCommonLabels?.lbl_common_address,
      'lbl_common_address'
    );
    const defaultTextLabel = renderLabel(
      this.billingLabels?.lbl_billing_default,
      'lbl_billing_default'
    );

    const { selectedShippingId } = this.state;
    const { registeredUserFormMode } = section;
    const hasAddresses = !isEmpty(userAddresses);
    const isSMSChecked = getIsGuestUser()
      ? initialValues?.smsSignUp?.sendOrderUpdate
      : shippingFormInput?.smsSignUp?.sendOrderUpdate;
    const renderEmailSignUp = () => {
      const isEmailSignedUp = initialValues?.emailSignUp?.emailSignUp;
      return (
        <Row fullBleed>
          <FormSection name="emailSignUp">
            <EmailSignUpCheckBox
              labels={emailSignUpLabels}
              fieldName="emailSignUp"
              bottomSeparator
              emailSignUpFlags={emailSignUpFlags}
              emailSignUpCaRichText={emailSignUpCaRichText}
              isSnJ={isSnJ}
              isUsSite={isUsSite}
              isGymboree={isGymboree}
              isChildrenPalace={isChildrenPalace}
              spc
              isCheckedTCP={isEmailSignedUp?.emailSignUpTCP}
              isCheckedGYM={isEmailSignedUp?.emailSignUpGYM}
              isLoginV2FlowEnabled={isLoginV2FlowEnabled}
            />
          </FormSection>
        </Row>
      );
    };
    if (registeredUserFormMode === REG_FORM_MODE.VIEW_ADDRESSES && hasAddresses) {
      const filterAddresses = () => {
        return userAddresses?.filter(
          (address) => address?.countryCode === 'US' || address?.countryCode === 'CA'
        );
      };

      const filteredAddressList = filterAddresses();
      return (
        <>
          <Row fullBleed>
            <Col
              colSize={{ small: 6, medium: 8, large: 12 }}
              className="address-dropDown"
              isEditing={isEditing}
              data-locator="address-dropdown"
            >
              <AddressCarousel
                addresses={filteredAddressList}
                selectedValue={selectedShippingId}
                onSelect={this.handleShippingAddressSelect}
                handleAddNew={() => this.updateRegFormMode(REG_FORM_MODE.ADD_NEW_ADDRESS)}
                handleEdit={(event, id) => {
                  if (orderTrackingEnhancementEnabled) {
                    event.stopPropagation();
                  }
                  this.updateRegFormMode(REG_FORM_MODE.EDIT_ADDRESS, id);
                }}
                isLoginV2FlowEnabled={isLoginV2FlowEnabled}
                isMakeDefaultUxUpdateEnabled={isMakeDefaultUxUpdateEnabled}
                defaultAddress={defaultAddress}
                makeDefaultAddress={makeDefaultAddress}
                makeDefaultTextLabel={makeDefaultTextLabel}
                addressTextLabel={addressTextLabel}
                defaultTextLabel={defaultTextLabel}
                isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
              />
            </Col>
          </Row>
          {isUsSite && isLoginV2FlowEnabled && !orderTrackingEnhancementEnabled && (
            <Row fullBleed>
              <FormSection name="smsSignUp">
                <SMSFormFields
                  labels={smsSignUpLabels}
                  colSize={{ small: 6, medium: 8, large: 12 }}
                  showDefaultCheckbox={false}
                  formName="ShippingForm"
                  formSection="smsSignUp"
                  variation="secondary"
                  isOrderUpdateChecked
                  smsOrderUpdatesRichText={smsSignUpLabels && smsSignUpLabels.smsSignupText}
                  spc
                  isLoginV2FlowEnabled={isLoginV2FlowEnabled}
                  isSMSChecked={isSMSChecked}
                />
              </FormSection>
            </Row>
          )}
          {!isUsSite && renderEmailSignUp()}
        </>
      );
    }
    if (
      registeredUserFormMode === REG_FORM_MODE.FIRST_ADDRESS ||
      registeredUserFormMode === REG_FORM_MODE.ADD_NEW_ADDRESS ||
      registeredUserFormMode === REG_FORM_MODE.EDIT_ADDRESS
    ) {
      return this.renderAddressFields();
    }
    return null;
  };

  onSaveToAccountChange = (e, value) => {
    const { dispatchFormFieldChange, section } = this.props;
    const { registeredUserFormMode } = section;
    const isFirstAddress = registeredUserFormMode === REG_FORM_MODE.FIRST_ADDRESS;
    dispatchFormFieldChange('saveToAddressBook', value);
    if (!value && !isFirstAddress) {
      dispatchFormFieldChange('defaultShipping', value);
    }
  };

  renderDefaultOptions = () => {
    const { section, shippingFormInput } = this.props;
    const { defaultShipping, addressId } = shippingFormInput;
    const { registeredUserFormMode } = section;
    const isFirstAddress = registeredUserFormMode === REG_FORM_MODE.FIRST_ADDRESS;
    const isEditAddress = registeredUserFormMode === REG_FORM_MODE.EDIT_ADDRESS;
    const showSaveToAddressBook = !(isEditAddress && addressId && !addressId.includes('me'));
    let defaultShippingValue = false;
    if (defaultShipping !== undefined && defaultShipping !== null) {
      defaultShippingValue = defaultShipping;
    }
    return (
      <Row fullBleed>
        {showSaveToAddressBook && (
          <Col colSize={{ small: 6, medium: 8, large: 12 }} className="elem-mb-LRG">
            <Field
              showDefaultCheckbox={true}
              component={InputCheckbox}
              className="addressCheckbox"
              name="saveToAddressBook"
              onChange={this.onSaveToAccountChange}
            >
              <BodyCopy fontSize="fs16" fontFamily="secondary" dataLocator="saveaddress-chk">
                {renderLabel(
                  this.shippingPageLabels?.lbl_shipping_saveToAccount,
                  'lbl_shipping_saveToAccount'
                )}
              </BodyCopy>
            </Field>
          </Col>
        )}
        {!isFirstAddress && (
          <Col colSize={{ small: 6, medium: 8, large: 12 }} className="elem-pb-XL">
            <Field
              showDefaultCheckbox={false}
              component={InputCheckbox}
              checked={defaultShippingValue}
              className="addressCheckbox"
              name="defaultShipping"
              disabled={isDefaultShippingDisabled}
            >
              <BodyCopy fontSize="fs16" fontFamily="secondary" dataLocator="shippingDefault-chk">
                {renderLabel(
                  this.shippingPageLabels?.lbl_shipping_defaultShipping,
                  'lbl_shipping_defaultShipping'
                )}
              </BodyCopy>
            </Field>
          </Col>
        )}
      </Row>
    );
  };

  render() {
    const { isEditing, className } = this.props;
    return (
      <div
        className={`${className} shipping-address-details`}
        isEditing={isEditing}
        data-locator="shipping-details"
      >
        {this.renderAddressForm()}
      </div>
    );
  }
}

RegisteredShippingFormV2.propTypes = propTypes;
RegisteredShippingFormV2.defaultProps = defaultProps;
export default withStyles(RegisteredShippingFormV2, styles);
export { RegisteredShippingFormV2 as RegisteredShippingFormV2Vanilla };
